import { Component, Input, ViewChild } from '@angular/core';
import { FCanvasComponent } from '@foblex/flow';
import { FlowNode, NodeManager } from '../node-manager';
import { FragQueryService } from 'src/injectables/frag-query.service';
import { BaseNode, FoblexNode, NODES_BASE_LENGTH } from './base-node';

@Component({
    selector: 'base-node',
    templateUrl: './base-node.component.html',
    styleUrls: ['./base-node.component.scss']
})
export class BaseNodeComponent{
    @Input() node!: BaseNode;
    @ViewChild(FCanvasComponent)
    public FoblexNode = FoblexNode;
    public readonly nodes$ = this.fragQuery.nodes$
    public nodes: FlowNode[] = [];
    // BaseLength of the node dimensions. so if relative height is 3 and relative width is 5, the actual height will be 150px and width will be 250px.
    public readonly BaseLength = NODES_BASE_LENGTH;

    constructor(
        private readonly fragQuery: FragQueryService,
        private nodeManager:NodeManager
    ) {

    }

   async deleteNode(): Promise<void> {
        await this.nodeManager.removeNode(this.node);
        this.nodes = this.nodeManager.getNodes()
    }
}
